import {
  isTenantScopeGrant,
  type Permission,
} from "../../shared/rbac/permissions";
import { type GrantLike, grantHasPermission } from "../../shared/rbac/roles";

type GrantWithScope = GrantLike & {
  scopeId: string;
  tenantId?: string | null;
};

// Mirrors the server's `hasAccess`: only `allow_all` at the tenant scope grants
// access everywhere. There is no scope hierarchy, so a specific permission must
// be granted on the scope itself -- a tenant-scoped `connected_app:write` does
// not cascade to individual connectors.
export function getWritableScopeIds(
  grants: readonly GrantWithScope[],
  scopeIds: readonly string[],
  permission: Permission
): Set<string> {
  const isTenantAdmin = grants.some(
    (g) => isTenantScopeGrant(g) && grantHasPermission(g, "allow_all")
  );
  if (isTenantAdmin) return new Set(scopeIds);

  const ids = new Set<string>();
  for (const g of grants) {
    if (grantHasPermission(g, permission)) ids.add(g.scopeId);
  }
  return ids;
}
